<div class="w-full bg-white radius-10">
    <div [style.border-bottom]="isExpanded ? 'solid 1px #DCEEFF' : 'none'">
        <div class="flex content-between p-20">
            <div class="">
                <div class="mb-10 flex gap-10 align-items-center">
                    <img src="assets/stats-icon.svg" alt="results icon">
                    <h1 class="dark-blue text-md no-margin text-lg">Résultats</h1>
                </div>

                <!-- <a href="{{blockchainLink}}/{{activeElectionToDisplay}}" target="_blank" rel="noopener noreferrer"
                    class="blockchain-link flex gap-5 align-items-center">
                    <img src="assets/global.svg" class="global-icon" /> <span>{{'POLL-PLANNED.POLL-BLOCKCHAIN' |
                        translate}}</span>
                </a> -->
            </div>

            <!-- <button (click)="toggleExpand()" class="pointer flex gap-10 align-items-center"
                style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
                <span class="dark-blue text-sm">{{isExpanded ? 'Réduire' : 'Afficher'}}</span>
                <span [style.transform]="isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'"
                    style="display: inline-block; transition: transform 0.3s;">›</span>
            </button> -->
            <div class="flex align-items-center gap-10">
                <div class="bg-pastel-green p-5 radius-5 flex gap-10 align-items-center"
                    *ngIf="cseRoundResult && votes - cseRoundResult.nullVotes >= cseRoundResult.votersCount / 2" style="border: solid 1px #63BA67;">
                    <img src="assets/valid-square-icon.svg" alt="">
                    <p class="no-margin text-sm strong-green">
                        Quorum atteint : {{votes - cseRoundResult.nullVotes}} ≥ {{cseRoundResult.votersCount / 2}}
                    </p>
                </div>
                <div class="bg-pastel-red p-5 radius-5 flex gap-10 align-items-center"
                    *ngIf="cseRoundResult && votes - cseRoundResult.nullVotes < cseRoundResult.votersCount / 2" style="border: solid 1px #EF4444;">
                    <img src="assets/warning-red-icon.svg" alt="">
                    <p class="no-margin text-sm strong-red">
                        Quorum non atteint : {{votes - cseRoundResult.nullVotes}} < {{cseRoundResult.votersCount / 2}} </p>
                </div>
            </div>
        </div>
    </div>
    <div style="border-bottom: solid 1px #DCEEFF;" *ngIf="cseRoundResult">
        <div class="p-20">
            <div style="display: grid; grid-template-columns: repeat(8, 1fr); gap: 10px">
                <app-cse-category [categoryTitle]="'INSCRITS (A)'" [value]="cseRoundResult.votersCount"></app-cse-category>
                <app-cse-category [categoryTitle]="'VOTANTS (B)'" [value]="votes"></app-cse-category>
                <app-cse-category [categoryTitle]="'BLANCS OU NULS (C)'" [value]="cseRoundResult.nullVotes"></app-cse-category>
                <app-cse-category [categoryTitle]="'VALABLEMENT EXPRIMÉS (D)'" [value]="votes - cseRoundResult.nullVotes"
                    [note]="'B - C'"></app-cse-category>
                <app-cse-category [categoryTitle]="'QUORUM (E)'" [value]="cseRoundResult.votersCount / 2"
                    [note]="'A ÷ 2'"></app-cse-category>
                <app-cse-category [categoryTitle]="'NOMBRE DE LISTE (L)'"
                    [value]="results.length - 1"></app-cse-category>
                <app-cse-category [categoryTitle]="'SIÈGE À POURVOIR (P)'"
                    [value]="pollData.rounds[activeElectionToDisplay].seats"></app-cse-category>
                <app-cse-category [categoryTitle]="'QUOTIENT (G)'" [note]="'D / P'"
                    [value]="((votes - cseRoundResult.nullVotes) / pollData.rounds[activeElectionToDisplay].seats) | number:'1.0-2'"></app-cse-category>
            </div>
        </div>
    </div>



</div>
